
import { useState, useEffect, useCallback } from 'react';
import { FeaturedTrack, FeaturedTrackState } from '@/types/featuredTracks';
import { fetchAllFeaturedTracks, fetchFeaturedTracksByUserId } from '@/services/featuredTracksService';

export function useFetchTracks() {
  const [state, setState] = useState<FeaturedTrackState>({
    tracks: [],
    isLoading: true,
    error: null
  });

  const fetchFeaturedTracks = useCallback(async () => {
    setState(prev => ({ ...prev, isLoading: true, error: null }));
    
    try {
      console.log("useFetchTracks: Fetching all featured tracks");
      const tracks = await fetchAllFeaturedTracks();
      setState({ tracks, isLoading: false, error: null });
    } catch (error: any) {
      console.error('Error fetching featured tracks:', error);
      setState(prev => ({ 
        ...prev, 
        isLoading: false, 
        error: error.message || 'Failed to fetch featured tracks'
      }));
    }
  }, []);

  const fetchTracksByUserId = useCallback(async (userId: string) => {
    setState(prev => ({ ...prev, isLoading: true, error: null }));
    
    try {
      console.log("useFetchTracks: Fetching tracks for user:", userId);
      const tracks = await fetchFeaturedTracksByUserId(userId);
      setState({ tracks, isLoading: false, error: null });
    } catch (error: any) {
      console.error('Error fetching user tracks:', error);
      setState(prev => ({ 
        ...prev, 
        isLoading: false, 
        error: error.message || 'Failed to fetch featured tracks'
      }));
    }
  }, []);

  return {
    ...state,
    fetchFeaturedTracks,
    fetchTracksByUserId,
    setTracks: (tracks: FeaturedTrack[]) => setState(prev => ({ ...prev, tracks }))
  };
}
